<template>
    <div style="margin-bottom: 80px;">
        <hr style="margin: 20px 0px 20px 0px;border-style: ridge;">
        <h3 class="hidden-sm-and-down alignleftTitle" >Ready Made Curtains
            <!-- <el-popover placement="top-start" title="Ready Made Curtains" width="200" trigger="hover"
                  content="Ready made curtains come with Pencil Pleat. Pencil pleat is also known as Tape Top or 3” Tape curtains, 
                  is the standard heading for curtains and valances. Pencil pleat curtain 
                  heading usually consists of three rows of string threaded through it for three 
                  hook positions to suit all types of track and pole. ">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover> -->
               <el-popover placement="top-start"  width="500" trigger="hover">
                    <table cellpadding="8px">                                         
                        <tr>
                            <td>Ready made curtains come with Pencil Pleat. Pencil pleat is also known as Tape Top or 3” Tape curtains, 
                  is the standard heading for curtains and valances. Pencil pleat curtain 
                  heading usually consists of three rows of string threaded through it for three 
                  hook positions to suit all types of track and pole.</td>                                                  
                            <td><a href="https://api.ifurniture.co.nz/image/pencil pleat.jpg" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/pencil pleat.jpg"></a></td>                                                      
                        </tr>                        
                    </table>                    
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
        
        </h3>
        <div  class="hidden-md-and-up" @click="addNewBlind">
        <el-tag type="success" style="font-size:10px"><i class="el-icon-plus"></i></el-tag>
        </div>
        <el-row :gutter="20" class="hidden-sm-and-down alignLeft">
            <el-col :lg="1" :md="1" :offset="2" class="alignCenter">No.</el-col>
            <el-col :lg="3" :md="3">Reference</el-col>
            <el-col :lg="6" :md="6">Size
                <el-popover placement="top-start" title="Size" width="310" trigger="hover">
                  <h3>please note the ready made curtains are not including tracks</h3>
                    <ul>
                        <li>S: Width 90cm – 130cm (Gathered) x Drop 160cm</li>
                        <li>S+: Width 150cm – 230cm (Gathered) x Drop 160cm</li>
                        <li>M: Width 90cm – 130cm (Gathered) x Drop 205cm</li>
                        <li>M+: Width 150cm – 230cm (Gathered) x Drop 205cm</li>
                        <li>L: Width 230cm – 330cm (Gathered) x Drop 160cm</li>
                        <li>XL: Width 230cm – 300cm (Gathered) x Drop 205cm</li>
                        <li>Super: Width 230cm – 300cm (Gathered) x Drop 220cm</li>
                        <li>Jumbo: Width 330cm – 480cm (Gathered) x Drop 220cm</li>
                    </ul>
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
            </el-col>
            <el-col :lg="2" :md="2">Fabric
                 <el-popover placement="top-start"  width="500" trigger="hover">
                    <table cellpadding="8px">
                        <th style="width:50px">Type</th>
                        <th style="width:100px">Price</th>
                        <th style="width:150px">Range</th>                       
                        <th style="width:50px">Sample Picture</th>                        
                        <tr>
                            <td>Plain</td>
                            <td>By size</td>
                            <td>dozens of choices in store and <a href="https://www.ifurniture.co.nz/Ready-Made-Curtains">online</a></td>                            
                            <td><a href="https://www.ifurniture.co.nz/Lined-Red-Readymade-Curtain--8-sizes" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/readymade_plain.jpeg"></a></td>                                                      
                        </tr>
                        <tr>
                            <td>Pattern</td>
                            <td>$55/m width (up to 270cm drop)</td>
                           <td>dozens of choices in store and <a href="https://www.ifurniture.co.nz/Ready-Made-Curtains">online</a></td>                              
                             <td><a href="https://www.ifurniture.co.nz/100-Block-Out-Mushroom-Readymade-Curtain--8-sizes" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/readymade_pattern.jpeg"></a></td>                                                      
                        </tr>                       
                    </table>                    
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>                
            </el-col>
            <el-col :lg="2" :md="2">Price</el-col>
            <el-col :lg="2" :md="2">Saved</el-col>
            <el-col :lg="4" :md="4">Operation</el-col>
        </el-row>
        <el-row v-for="(chooseReadyMadeCurtain,index) in chooseReadyMadeCurtains" :key="index" class="rowpadding hidden-sm-and-down">
            <el-col :lg="1" :md="1" :offset="2" class="colpadding">{{index+1}}</el-col>
            <el-col :lg="3" :md="3" class="colpadding">
                <el-input v-model="chooseReadyMadeCurtain.Window"  @input="inputChange(index)"></el-input>
            </el-col>
            <el-col :lg="6" :md="6" class="colpadding">
                 <el-select v-model="chooseReadyMadeCurtain.Size" placeholder="Size" style="width:100%" value-key="choseRCSize" @change="addCurtain(index)">
                 <el-option v-for="item in sizeOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
            </el-col>
           
            <el-col :lg="2" :md="2" class="colpadding">
                 <el-select v-model="chooseReadyMadeCurtain.Fabric" placeholder="Fabric" value-key="choseRCFabric" @change="addCurtain(index)">
                 <el-option v-for="item in fabricOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option> 
                 </el-select>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding alignLeft">
                  <div class="info priceStyle">${{chooseReadyMadeCurtain.Price}}</div>
            </el-col>
             <el-col :lg="2" :md="2" class="colpadding">
               <i :class="chooseReadyMadeCurtain.Saved"></i>
            </el-col>
            <el-col :lg="4" :md="4" class="colpadding">
              <el-button type="danger" @click="removeBlind(chooseReadyMadeCurtain)">Delete</el-button>
            </el-col>
        </el-row>
          <el-row class="rowpadding hidden-sm-and-down alignLeft" style="margin-left:10%">
             <el-button type="success" @click="addNewBlind">Add a Ready Made Curtain</el-button>
        </el-row>
        <div class="hidden-md-and-up">
        <el-card class="box-card" v-for="(chooseReadyMadeCurtain,index) in chooseReadyMadeCurtains" :key="index" >
         <div slot="header" class="clearfix">
          <span>No.{{index+1}}</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="success" @click="addNewBlind">Add</el-button> -->
         </div>
         <div style="text-align:left">
             <el-row class="rowpadding">
             <el-col :sm="6" :xs="6" style=" word-wrap:break-word; ">Reference</el-col>
              <el-col :sm="16" :xs="16"><el-input v-model="chooseReadyMadeCurtain.Window"  @input="inputChange(index)"></el-input></el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">
                    Size
                    <el-popover placement="top-start" width="310" trigger="click">
                      <h3>please note the ready made curtains are not including tracks</h3>
                    <ul>
                        <li>S: Width 90cm – 130cm (Gathered) x Drop 160cm – $28</li>
                        <li>S+: Width 150cm – 230cm (Gathered) x Drop 160cm – $39.95</li>
                        <li>M: Width 90cm – 130cm (Gathered) x Drop 205cm – $45</li>
                        <li>M+: Width 150cm – 230cm (Gathered) x Drop 205cm – $49.95</li>
                        <li>L: Width 230cm – 330cm (Gathered) x Drop 160cm – $59.95</li>
                        <li>XL: Width 230cm – 300cm (Gathered) x Drop 205cm – $75</li>
                        <li>Super: Width 230cm – 300cm (Gathered) x Drop 220cm – $95</li>
                        <li>Jumbo: Width 330cm – 480cm (Gathered) x Drop 220cm – $125</li>
                    </ul>
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="chooseReadyMadeCurtain.Size" placeholder="Size" value-key="choseRCSizeM" @change="addCurtain(index)">
                 <el-option v-for="item in sizeOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">Fabric
                      <el-popover placement="top-start" title="Fabric" width="200" trigger="click">
                    <img src="../assets/i9.png" alt="" style="width:200px;hight:400px">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="chooseReadyMadeCurtain.Fabric" placeholder="Fabric" value-key="choseRCFrbricM" @change="addCurtain(index)">
                 <el-option v-for="item in fabricOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
            </el-row>
         </div>
         <hr>
         <div>Price:
             <span class="info priceStyle">${{chooseReadyMadeCurtain.Price}}</span>
             Saved:
             <i :class="chooseReadyMadeCurtain.Saved"></i>
             <el-button style="float: right; padding: 3px 0" type="danger" @click="removeBlind(chooseReadyMadeCurtain)">Delete</el-button>
         </div>
        </el-card>
       </div> 
    </div>
</template>
<script>
import { addCurtain } from "@/api/AddCurtain";
import { deleteCurtain } from "@/api/DeleteCurtain";
import _ from "lodash";
export default {
  name: "ReadyMadeCurtains",
  props: ["readyMadeCurtains", "options"],

  data() {
    return {
      chooseReadyMadeCurtains: this.readyMadeCurtains,
      allOptions: [],
      sizeOptions: [],
      fabricOptions: []
    };
  },
  watch: {
    options: {
      deep: true,
      handler(nv, ov) {
        this.allOptions = nv;
        this.getOprtions();
      }
    }
  },
  methods: {
    addNewBlind() {
      const newBlind = {
        CurtainId: "",
        Window: "",
        Size: "",
        Fabric: "",
        Price: 0
      };
      this.chooseReadyMadeCurtains.push(newBlind);
      window.scrollTo(0, document.body.scrollHeight);
    },
    removeBlind(item) {
      var index = this.chooseReadyMadeCurtains.indexOf(item);
      if (index !== -1) {
        if (this.chooseReadyMadeCurtains[index].CurtainId !== "") {
          deleteCurtain(this.chooseReadyMadeCurtains[index].CurtainId)
            .then(res => {
              if (res.data.Success) {
                this.$store.commit("changeCurtain");
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        }
        this.chooseReadyMadeCurtains.splice(index, 1);
      }
    },
    getOprtions() {
      this.allOptions.forEach(item => {
        if (item.modelName === "Ready Made Curtains") {
          this.sizeOptions = item.Sizes;
     
          this.fabricOptions = item.Fabrics;
        }
      });
    },
    addCurtain(index) {
      if (
        this.chooseReadyMadeCurtains[index].Size !== "" &&
        this.chooseReadyMadeCurtains[index].Fabric !== ""
      ) {
        const CurtainQuoationId = localStorage.getItem("curtain_quoationId");
        const CurtainCustomerId = localStorage.getItem("curtain_customerId");
        const newCurtain = {};
        newCurtain.CurtainId = this.chooseReadyMadeCurtains[index].CurtainId;
        newCurtain.RoomName = this.chooseReadyMadeCurtains[index].Window;
        newCurtain.FabricType = this.chooseReadyMadeCurtains[index].Fabric;
        newCurtain.Size = this.chooseReadyMadeCurtains[index].Size;
        newCurtain.Price = this.chooseReadyMadeCurtains[index].Price;
        newCurtain.ModelName = "Ready Made Curtains";

        this.$nextTick(() => {
          addCurtain(CurtainQuoationId, CurtainCustomerId, newCurtain)
            .then(res => {
              this.chooseReadyMadeCurtains[
                index
              ].Price = res.data.CPrice.toFixed(2);
              this.chooseReadyMadeCurtains[index].CurtainId =
                res.data.CurtainId;
              this.chooseReadyMadeCurtains[index].Saved =
                "el-icon-check dataSaved";
              this.$store.commit("changeCurtain");
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        });
      } else {
        this.chooseReadyMadeCurtains[index].Saved = "el-icon-close";
        if (this.chooseReadyMadeCurtains[index].CurtainId !== "") {
          deleteCurtain(this.chooseReadyMadeCurtains[index].CurtainId)
            .then(res => {
              if (res.data.Success) {
                this.chooseReadyMadeCurtains[index].CurtainId = "";
                this.chooseReadyMadeCurtains[index].Price = 0;
                this.$store.commit("changeCurtain");
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        }
      }
    },
    inputChange: _.debounce(function(index) {
      this.addCurtain(index);
    }, 500)
  }
};
</script>
<style>
.box-card {
  margin: 10px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.rowpadding {
  padding: 5px;
}
.colpadding {
  padding: 3px;
}
.dataSaved {
  background-color: green;
  color: white;
  font-weight: 400;
}
.alignleftTitle {
  text-align: left;
  margin-left: 10%;
}
.alignLeft {
  text-align: left;
}
.alignCenter {
  text-align: center;
}
.priceStyle {
  margin-top: 10px;
  font-weight: bold;
  color: #0066cc;
}
</style>



// WEBPACK FOOTER //
// src/components/ReadyMadeCurtains.vue